const Views = {
  Tiles: 'tiles',
  About: 'about',
  QAndA: 'qa',
  EmptyState: 'emptystate',
  RbcX: 'rbcx',
  Kudos: 'kudos'
};

export default Views



// WEBPACK FOOTER //
// ./src/Views.js